import {
  Avatar,
  Backdrop,
  Box,
  Button,
  Checkbox,
  Chip,
  CircularProgress,
  Collapse,
  FormControl,
  Grid,
  ListItemText,
  MenuItem,
  Paper,
  Select,
  Stack,
  Typography,
  styled,
  TextField,
  Autocomplete,
  Divider,
  ThemeProvider,
  Tooltip,
} from "@mui/material";
import { DataGrid } from "@mui/x-data-grid";
import React, { useEffect, useState } from "react";
import MainCard from "../../../components/Maincard";
import InfoCard from "./InfoCard";
import EventFilter from "./EventFilter";
import CustomSnackbar from "../../components/ui-component/snackbar/CustomSnackbar";
import { useNavigate } from "react-router-dom";
import { fDate } from "../../../utils/formatTime";
import CustomPopup from "../../../components/CustomPopup";

import SearchIcon from "@mui/icons-material/Search";
import ClearIcon from "@mui/icons-material/Clear";
import NoenquiryForm from "../../components/DataTransferComp.jsx/NoenquiryForm";
import {
  format,
  subMonths,
  addMonths,
  isSameMonth,
  getMonth,
  getYear,
} from "date-fns";
import EmailIcon from "@mui/icons-material/Email";
import NoeMailForm from "../../components/DataTransferComp.jsx/NoMailForm";
import BulkMailform from "../../components/BulkEmail/BulkMailform";
import BulkEmailPopup from "../../components/BulkEmail/BulkEmailPopup";
import { CSVExport } from "../../components/ui-component/table/CSVExport";
import { useGetTokenOrLogout } from "../../../utils/token";
import MassTaskAssign from "../../components/DataTransferComp.jsx/MassTaskAssign";
import FilledButtonComponent from "../../newComponent/filledButtonComponent";
import OutlinedButtonComp from "../../newComponent/OutlinedButtonComp";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";

import CustomTextFieldComp from "../../newComponent/customTextFieldComp";
import CustomAutocompleteComp from "../../newComponent/AutocompleteComp";
import MassTaskAssignButton from "../../newComponent/NewButtonComp/MassTaskAssignButton";
import SendEmailButton from "../../newComponent/NewButtonComp/SendEmailButton";
import SelectedItemButton from "../../newComponent/NewButtonComp/SelectedItemButton";
import SearchButton from "../../newComponent/NewButtonComp/SearchButton";
import ResetButtonComp from "../../newComponent/NewButtonComp/ResetButtonComp";
import SearchTextFieldComp from "../../newComponent/newtextfieldComp/SearchTextFieldComp";

export default function DetailedReport({ open }) {
  const API_ENDPOINT = process.env.REACT_APP_API_ENDPOINT;
  const userId = localStorage.getItem("userId");
  const userRole = localStorage.getItem("userRole");
  const getTokenOrLogout = useGetTokenOrLogout();

  const [openMask, setOpenMask] = useState(false);
  const [eventData, setEventData] = useState([]);
  const [selectedid, setSelectedid] = useState([]);
  const [selectedEnquiryId, setSelectedEnquiryids] = useState([]);
  const [branchlist, setBranchlist] = useState([]);
  const [branch, setBranch] = useState([]);
  const [RegistrationList, setRegistrationList] = useState([]);
  const [resterationstatus, setRegistrationstatus] = useState([]);
  const [confirmByStudent, setConfirmByStudent] = useState([]);
  const [eventList, setEventList] = useState([]);
  const [allcampaignList, setAllCampaignList] = useState([]);
  const [eventname, setEventName] = useState([]);
  const [registerdByList, setRegisteredByList] = useState([]);
  const [registerBy, setRegisterdBy] = useState([]);
  const [permanentlyOwner, setPermentlyonner] = useState([]);
  const [servicelist, setServiceList] = useState([]);
  const [service, setService] = useState([]);
  const [prospectiveLevelList, setProspectiveLevelList] = useState([]);
  const [prosectiveLevel, setProspectiveLevel] = useState([]);
  const [leadStageList, setLeadstageList] = useState([]);
  const [leadstage, setLeadstage] = useState([]);
  const [nearestBranch, setNearestBranch] = useState([]);
  const [countrylist, setcountrylist] = useState([]);
  const [country, setCountry] = useState([]);
  const [eventType, setEventType] = useState(null);
  const [checkboxChange, setCheckBoxChange] = useState(false);
  const [fromDate, setFromDate] = useState("");
  const [endDate, setEndDate] = useState("");
  const [eventloading, setEventLoading] = useState(false);
  const [eventOriginalData, setEventOriginalData] = useState([]);
  const [eventRowData, setEventRowData] = useState([]);
  const [selectedFilters, setSelectedFilters] = useState([]);
  const [OpenEmailPopup, setOpenEmailPopup] = useState(false);
  const [subServiceName, setSubServiceName] = useState([]);
  const [subServiceList, setSubsubServiceList] = useState([]);

  const [isDownloadAccess, setIsDownloadAccess] = useState(false);
  const [exportData, setExportData] = useState([]);

  const [isSelectAllChecked, setIsSelectAllChecked] = useState(false);
  const [selectedMonthYear, setSelectedMonthYear] = useState(null);
  const [eventFromDate, setEventFromDate] = useState("");
  const [eventToDate, setEventToDate] = useState("");
  const [gridKey, setGridKey] = useState(0);
  const [pagination, setPagination] = useState({
    page: 0,
    pageSize: 100,
  });
  const [confirmationStatus, setConfirmationStatus] = useState([]);

  // Current Date
  const [visibleRowIds, setVisibleRowIds] = useState([]); // Store current page's row IDs
  const [isIndeterminate, setIsIndeterminate] = useState(false);
  const [prevPageSize, setPrevPageSize] = useState(pagination.pageSize);
  const currentDate = new Date();
  const [openstatus, setOpenStatus] = useState(false);
  const [openstages, setOpenStages] = useState(false);

  // Store  5 months
  const dates = [
    subMonths(currentDate, 2),
    subMonths(currentDate, 1),
    currentDate,
    addMonths(currentDate, 1),
    addMonths(currentDate, 2),
  ];

  const noOptionsText = "Loading...";

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await fetch(`${API_ENDPOINT}subservice`);
        if (response.ok) {
          const data = await response.json();

          setSubsubServiceList(data);
        } else {
          throw new Error(`Request failed with status: ${response.status}`);
        }
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };

    fetchData();
  }, []);

  const allSubservice = [{ name: "Select All", id: 0 }, ...subServiceList];

  // handle subservice
  const handleChangeSubservice = (id) => {
    setEventName([]);
    setEventList([]);
    setEventFromDate("");
    setEventToDate("");
    setEventType(null);
    setSelectedMonthYear(null);
    if (id === 0) {
      // Handle "Select All"
      setSubServiceName(
        (prevSelected) =>
          prevSelected.length === subServiceList.length
            ? [] // Deselect all
            : subServiceList.map((subservice) => subservice.id), // Select all
      );
    } else {
      // Handle individual subservice selection
      setSubServiceName(
        (prevSelected) =>
          prevSelected.includes(id)
            ? prevSelected.filter((subserviceId) => subserviceId !== id) // Remove ID if already selected
            : [...prevSelected, id], // Add ID if not selected
      );
    }
  };

  console.log("subServiceName", subServiceName);

  // Fetch Currnet Month data bydefault
  // useEffect(() => {

  //   handleSubmitDurationdata(currentDate);
  // }, []);

  // Fetch Custom Event Data
  const handleChangeEventFromdate = (e) => {
    setEventFromDate(e.target.value);
  };

  const handleChangeEventTodate = (e) => {
    setEventToDate(e.target.value);
  };

  const handleApplyFilter = () => {
    getEventData(null, eventType, eventFromDate, eventToDate);
  };
  // Fetch data by all, past , and date
  const handleEventData = async ({ date = null, eventType = null }) => {
    // Reset dependent states
    setEventName([]);
    setEventList([]);
    setEventFromDate("");
    setEventToDate("");
    setSelectedMonthYear(date ? format(date, "MMMM,yyyy") : null);
    setEventType(eventType);

    // Determine which filter to use for fetching data
    const filter = date ? format(date, "MMMM,yyyy") : eventType;

    if (eventType !== "custom") {
      getEventData(date, filter, null, null);
    }
  };

  const getEventData = async (date, eventcriteria, fromdate, todate) => {
    const requestData = {
      filter: date === null ? eventcriteria : format(date, "MMMM, yyyy"),
      sub_service_id: subServiceName,
      from_date: fromdate || null,
      to_date: todate || null,
    };
    setEventLoading(true);
    try {
      const response = await fetch(`${API_ENDPOINT}campaign/eventbymonth`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(requestData),
      });
      const result = await response.json();

      if (response.ok) {
        const sortedData = result.sort(
          (a, b) => new Date(b.createdAt) - new Date(a.createdAt),
        );
        setEventList(sortedData);
        setEventLoading(false);
      } else if (response.status === 404) {
        setEventList([]);
        setEventLoading(false);
      } else if (response.status === 400) {
        setEventList([]);
        setEventLoading(false);
        showSnackbar(result.message, "error");
      } else {
        setEventList([]);
        setEventLoading(false);
        showSnackbar("server error", "error");
      }
    } catch (error) {
      setEventList([]);
      setEventLoading(false);
      showSnackbar("server error", "error");
    }
  };

  const handleOpenmask = () => {
    setOpenMask(true);
  };

  const handleClosemask = () => {
    setOpenMask(false);
  };
  const handleOpenEmail = () => {
    setOpenEmailPopup(true);
  };

  const handleCloseEmail = () => {
    setOpenEmailPopup(false);
  };

  const ITEM_HEIGHT = 48;
  const ITEM_PADDING_TOP = 8;
  const MenuProps = {
    PaperProps: {
      style: {
        maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
        width: 250,
      },
    },
  };

  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const [snackbarOpen, setSnackbarOpen] = React.useState(false);
  const [snackbarMessage, setSnackbarMessage] = React.useState("");
  const [snackbarSeverity, setSnackbarSeverity] = React.useState("success");

  const showSnackbar = (message, severity) => {
    setSnackbarMessage(message);
    setSnackbarSeverity(severity);
    setSnackbarOpen(true);
  };

  // fetch todays regi
  useEffect(() => {
    setLoading(true);
    const token = getTokenOrLogout();
    if (!token) return;
    let headers = {
      Authorization: `Bearer ${token}`,
    };
    fetch(`${API_ENDPOINT}route2.0/showtodayregistrationstatus/${userId}`, {
      headers,
    })
      .then((response) => {
        if (response.ok) {
          return response.json();
        } else if (response.status === 404) {
          navigate("/page404");
        } else if (response.status === 401) {
          navigate("/page401");
        } else if (response.status === 403) {
          navigate("/page403");
        } else if (response.status === 440) {
          navigate("/page440");
        } else {
          navigate("/page500");
        }
      })
      .then((data) => {
        if (!data) return; // Stop further execution if data is not present

        if (data.length === 0) {
          showSnackbar("No any data vailable for today", "error");
        }
        const sortedData = data.sort(
          (a, b) => new Date(b.createdAt) - new Date(a.createdAt),
        );
        setEventData(sortedData);
        setEventOriginalData(sortedData);
        setEventRowData(sortedData);
        setLoading(false);
      })
      .catch((error) => {
        navigate("/page500");
      });
  }, [userId]);

  const handleSubmit = async (event) => {
    setSelectedEnquiryids([]);
    setVisibleRowIds([]);
    setSelectedFilters([]);
    setIsIndeterminate(false);
    setIsSelectAllChecked(false);
    setSelectedid([]);
    setGridKey((prev) => prev + 1);

    if (eventname.length === 0) {
      showSnackbar("Please Select Event First", "error");
      return;
    }

    const token = getTokenOrLogout();
    if (!token) return;
    let headers = {
      Authorization: `Bearer ${token}`,
      "Content-Type": "application/json", // Make sure to keep the content type
    };

    event.preventDefault();
    setLoading(true);
    const requestData = {
      event: eventname.map((i) => i.id),
      from_date: fromDate || null,
      end_date: endDate || null,
      // branch: branch,
      registered_by: registerBy.map((i) => i.id),
      // permanetly_owner: permanentlyOwner,
      // service: service,
      // prospective_level: prosectiveLevel,
      // lead_stage: leadstage,
      registration_status: resterationstatus.map((i) => i.id),
      confirm_by_student: confirmationStatus.map((i) => i.value),
      // registered_country: country,
      // nearest_branch: nearestBranch,
      user_id: parseInt(userId),
    };
    console.log("RD", requestData);

    try {
      const response = await fetch(
        `${API_ENDPOINT}route2.0/showallregistrationstatus`,
        {
          method: "POST",
          headers,
          body: JSON.stringify(requestData),
        },
      );

      if (response.ok) {
        const result = await response.json();
        const sortedData = result.sort(
          (a, b) => new Date(b.createdAt) - new Date(a.createdAt),
        );
        setEventData(sortedData);
        setEventOriginalData(sortedData);
        setLoading(false);
      } else if (response.status === 404) {
        navigate("/page404");
      } else if (response.status === 401) {
        navigate("/page401");
      } else if (response.status === 403) {
        navigate("/page403");
      } else if (response.status === 440) {
        navigate("/page440");
      } else {
        navigate("/page500");
      }
    } catch (error) {
      navigate("/page500");
    }
  };

  const handleresetFilterData = () => {
    setEventName([]);
    setFromDate("");
    setEndDate("");
    setBranch([]);
    setRegisterdBy([]);
    setPermentlyonner([]);
    setService([]);
    setProspectiveLevel([]);
    setLeadstage([]);
    setRegistrationstatus([]);
    setConfirmByStudent([]);
    setCountry([]);
    setNearestBranch([]);
    setEventOriginalData(eventRowData);
    setEventData(eventRowData);
    setSubServiceName([]);
    setSelectedMonthYear(null);
    setEventList([]);
    setEventType(null);
    setEventFromDate("");
    setEventToDate("");
    setGridKey((prev) => prev + 1);
    setSelectedEnquiryids([]);
    setVisibleRowIds([]);
    setSelectedFilters([]);
    setIsIndeterminate(false);
    setIsSelectAllChecked(false);
    setSelectedid([]);
  };

  // Upadate current page ids when pagination is chnages
  useEffect(() => {
    console.log("pagination", pagination, selectedid);
    setPrevPageSize(pagination.pageSize);

    // new pagesize is less than prev page size then deselct all selected ids first
    if (pagination.pageSize !== prevPageSize) {
      setSelectedid([]);
      return;
    }

    // Update visible row IDs when pagination changes
    const currentPageRows = eventOriginalData.slice(
      pagination.page * pagination.pageSize,
      (pagination.page + 1) * pagination.pageSize,
    );
    const visibleIds = currentPageRows.map((row) => row.id);
    setVisibleRowIds(visibleIds);

    // If there are no visible rows, set SelectAllChecked to false
    if (visibleIds.length === 0) {
      setIsSelectAllChecked(false);
      setIsIndeterminate(false);
      return;
    }

    // Check if all visible rows are selected
    const allVisibleSelected = visibleIds.every((id) =>
      selectedid.includes(id),
    );
    const someVisibleSelected = visibleIds.some((id) =>
      selectedid.includes(id),
    );

    setIsSelectAllChecked(allVisibleSelected);
    setIsIndeterminate(someVisibleSelected && !allVisibleSelected);
  }, [pagination, eventOriginalData, selectedid]);

  // HandleSelectAllCheckBox
  const handleSelectAllChange = (event) => {
    const checked = event.target.checked;
    setIsSelectAllChecked(checked);

    if (checked) {
      // Select all visible row IDs
      setSelectedid((prevSelectedIds) => [
        ...new Set([...prevSelectedIds, ...visibleRowIds]),
      ]);
    } else {
      // Deselect all visible row IDs
      setSelectedid((prevSelectedIds) =>
        prevSelectedIds.filter((id) => !visibleRowIds.includes(id)),
      );
    }
  };

  // Individual CheckBox
  const handleCheckboxChange = (event, id) => {
    const checked = event.target.checked;

    setSelectedid((prevSelectedIds) => {
      if (checked) {
        const newSelected = [...prevSelectedIds, id];
        // Check if all visible rows are selected after this checkbox is checked
        const allVisibleSelected = visibleRowIds.every((rowId) =>
          newSelected.includes(rowId),
        );
        setIsSelectAllChecked(allVisibleSelected);
        setIsIndeterminate(!allVisibleSelected);

        return newSelected;
      } else {
        // Deselect the row ID
        const newSelected = prevSelectedIds.filter((rowId) => rowId !== id);
        setIsSelectAllChecked(false);
        setIsIndeterminate(
          visibleRowIds.some((rowId) => newSelected.includes(rowId)),
        );

        return newSelected;
      }
    });
  };

  // Select All Row
  const handleSelectAllData = () => {
    if (eventOriginalData.length === selectedid.length) {
      setSelectedid([]);
    } else {
      const allRowIds = eventOriginalData.map((row) => row.id);
      setSelectedid(allRowIds);
    }
  };

  // Select EnquiryIds
  useEffect(() => {
    if (selectedid.length > 0) {
      console.log("taskIds", selectedid);
      const enquiryIds = eventOriginalData.filter((id) =>
        selectedid.includes(id?.id),
      );
      const selectedEnquiryids = enquiryIds.map((i) => i.enquiry_id?.id);
      setSelectedEnquiryids(selectedEnquiryids);
    }
  }, [selectedid]);

  const columns = [
    {
      field: "selection",
      sortable: false,
      disableColumnMenu: true,

      renderHeader: (params) => (
        <Checkbox
          size="small"
          checked={isSelectAllChecked}
          indeterminate={isIndeterminate}
          onChange={handleSelectAllChange}
        />
      ),
      headerClassName: "header-cell",
      width: 70,
      renderCell: (params) => {
        const isChecked = selectedid.includes(params.row?.id);
        return (
          <Checkbox
            size="small"
            checked={isChecked}
            onChange={(event) => handleCheckboxChange(event, params.row?.id)}
          />
        );
      },
    },
    {
      field: "name",
      headerName: "Name",
      width: 200,
      sortable: true, // Enable sorting here
      headerClassName: "header-cell",
      headerAlign: "center",
      align: "center",
      valueGetter: (params) =>
        `${params.row?.enquiry_id?.first_name || ""}{" "}
          ${params.row?.enquiry_id?.last_name || ""}`,
      renderCell: (params) => (
        <div
          style={{ color: "#2196F3", cursor: "pointer" }}
          onClick={() =>
            window.open(
              `/enquirydetails/${params?.row?.enquiry_id?.id}`,
              "_blank",
            )
          }
        >
          {params.row?.enquiry_id?.first_name}{" "}
          {params.row?.enquiry_id?.last_name}
        </div>
      ),
    },
    {
      field: "phone",
      headerName: "Mobile",
      width: 150,
      headerClassName: "header-cell",
      headerAlign: "center",
      align: "center",
      valueGetter: (params) => `${params.row?.enquiry_id?.mobile || ""}`,
      renderCell: (params) => (
        <div>
          {" "}
          {params.row?.enquiry_id?.mobile_country_code}
          {userRole === "advisor" || userRole === "trainer"
            ? params.row?.enquiry_id?.mobile?.replace(/.(?=.{4,}$)/g, "*")
            : params.row?.enquiry_id?.mobile}
        </div>
      ),
    },

    {
      field: "email",
      headerName: "Email",
      width: 250,
      headerClassName: "header-cell",
      headerAlign: "center",
      align: "center",
      valueGetter: (params) => `${params.row?.enquiry_id?.email || ""}`,
      renderCell: (params) => {
        const email = params.row?.enquiry_id?.email || "";

        if (email.length <= 5) return email; // not enough to mask

        const start = email.slice(0, 2);
        const end = email.slice(-3);
        return `${start}***${end}`;
      },
    },
    {
      field: "contact",
      headerName: "Contact",
      width: 100,
      headerClassName: "header-cell",
      headerAlign: "center",
      align: "center",
      valueGetter: (params) =>
        `${params.row?.enquiry_id?.connected_call || ""}`,

      renderCell: (params) => (
        <div>{params.row?.enquiry_id?.connected_call} </div>
      ),
    },
    {
      field: "nonContact",
      headerName: "Non Contact",
      width: 100,
      headerClassName: "header-cell",
      headerAlign: "center",
      align: "center",
      valueGetter: (params) =>
        `${params.row?.enquiry_id?.not_connected_call || ""}`,
      renderCell: (params) => (
        <div>{params.row?.enquiry_id?.not_connected_call} </div>
      ),
    },
    {
      field: "totalOpenTask",
      headerName: "Open Task",
      width: 100,
      headerClassName: "header-cell",
      headerAlign: "center",
      align: "center",
      valueGetter: (params) =>
        `${params.row?.enquiry_id?.total_open_task || ""}`,
      renderCell: (params) => (
        <div>{params.row?.enquiry_id?.total_open_task} </div>
      ),
    },
    {
      field: "lastFollowUp",
      headerName: "Last Follow Up ",
      width: 100,
      headerClassName: "header-cell",
      headerAlign: "center",
      align: "center",
      valueGetter: (params) =>
        `${params.row?.enquiry_id?.last_follow_up_date || ""}`,
      renderCell: (params) => (
        <div>{params.row?.enquiry_id?.last_follow_up_date} </div>
      ),
    },
    {
      field: "nextDueDate",
      headerName: "Next Due Date ",
      width: 100,
      headerClassName: "header-cell",
      headerAlign: "center",
      align: "center",
      valueGetter: (params) =>
        `${params.row?.enquiry_id?.next_follow_up_date || ""}`,
      renderCell: (params) => (
        <div>{params.row?.enquiry_id?.next_follow_up_date} </div>
      ),
    },
    {
      field: "eventName",
      headerName: "Event Name",
      width: 550,
      headerClassName: "header-cell",
      headerAlign: "center",
      align: "center",
      valueGetter: (params) => `${params.row?.event_id?.campaign_name || ""}`,
      renderCell: (params) => <div>{params.row?.event_id?.campaign_name}</div>,
    },
     {
      field: "campaignName",
      headerName: "Campaign Name",
      width: 550,
      
      headerClassName: "header-cell",
      headerAlign: "center",
      align: "center",
      valueGetter: (params) => `${params.row?.enquiry_id?.campaign_id?.campaign_name || ""}`,
      renderCell: (params) => <div>{params.row?.enquiry_id?.campaign_id?.campaign_name}</div>,
    },
    {
      field: "dateOfRegistration",
      headerName: "Date Of Registration",
      width: 150,
      headerClassName: "header-cell",
      valueGetter: (params) => `${fDate(params.row?.registered_date || "")}`,
      renderCell: (params) => <div>{fDate(params.row?.registered_date)}</div>,
      headerAlign: "center",
      align: "center",
    },

    {
      field: "registerBy",
      headerName: "Register By",
      width: 150,
      headerClassName: "header-cell",
      valueGetter: (params) =>
        `${params.row?.registered_by?.first_name || ""}{" "}
          ${params.row?.registered_by?.last_name || ""}`,
      renderCell: (params) => (
        <div>
          {params.row?.registered_by?.first_name}{" "}
          {params.row?.registered_by?.last_name}
        </div>
      ),
      headerAlign: "center",
      align: "center",
    },
    {
      field: "permanentlyOwner",
      headerName: "Permanently Owner",
      width: 150,
      headerClassName: "header-cell",
      headerAlign: "center",
      align: "center",
      valueGetter: (params) =>
        `${params.row?.enquiry_id?.assign_to?.first_name || ""}{" "}
          ${params.row?.enquiry_id?.assign_to?.last_name || ""}`,
      renderCell: (params) => (
        <div>
          {params.row?.enquiry_id?.assign_to?.first_name}{" "}
          {params.row?.enquiry_id?.assign_to?.last_name}{" "}
        </div>
      ),
    },

    {
      field: "branch",
      headerName: "Branch",
      width: 150,
      headerClassName: "header-cell",
      headerAlign: "center",
      align: "center",
      valueGetter: (params) =>
        `${params.row?.enquiry_id?.branch_id?.branch_name || ""}`,
      renderCell: (params) => (
        <div>{params.row?.enquiry_id?.branch_id?.branch_name} </div>
      ),
    },

    {
      field: "nearestBranch",
      headerName: "Nearest Branch",
      width: 150,
      headerClassName: "header-cell",
      headerAlign: "center",
      align: "center",
      valueGetter: (params) =>
        `${params.row?.enquiry_id?.nearest_branch_id?.branch_name || ""}`,
      renderCell: (params) => (
        <div>{params.row?.enquiry_id?.nearest_branch_id?.branch_name} </div>
      ),
    },

    {
      field: "prospectiveLevel",
      headerName: "Prospective Level",
      width: 150,
      headerClassName: "header-cell",
      headerAlign: "center",
      align: "center",
      valueGetter: (params) =>
        `${
          params.row?.enquiry_id?.prospective_level_id?.prospective_level || ""
        }`,
      renderCell: (params) => (
        <div>
          {params.row?.enquiry_id?.prospective_level_id?.prospective_level}
        </div>
      ),
    },
    {
      field: "leadStage",
      headerName: "Lead Stage",
      width: 150,
      headerClassName: "header-cell",
      headerAlign: "center",
      align: "center",
      valueGetter: (params) =>
        `${params.row?.enquiry_id?.stage_id?.stage_name || ""}`,
      renderCell: (params) => (
        <div>{params.row?.enquiry_id?.stage_id?.stage_name}</div>
      ),
    },
    {
      field: "enq_date",
      headerName: "Enquiry Date",
      width: 150,
      headerClassName: "header-cell",
      headerAlign: "center",
      align: "center",
      valueGetter: (params) => `${params.row?.enquiry_id?.enquiry_date || ""}`,
      renderCell: (params) => <div>{params.row?.enquiry_id?.enquiry_date}</div>,
    },
    {
      field: "lead_source",
      headerName: "Lead Source",
      width: 150,
      headerClassName: "header-cell",
      headerAlign: "center",
      align: "center",
      valueGetter: (params) =>
        `${params.row?.enquiry_id?.lead_source_type_id?.name || ""}`,
      renderCell: (params) => (
        <div>{params.row?.enquiry_id?.lead_source_type_id?.name}</div>
      ),
    },
    {
      field: "sub_lead_source",
      headerName: "Sub Lead Source",
      width: 150,
      headerClassName: "header-cell",
      headerAlign: "center",
      align: "center",
      valueGetter: (params) =>
        `${params.row?.enquiry_id?.sub_lead_source_type_id?.source_type || ""}`,
      renderCell: (params) => (
        <div>
          {params.row?.enquiry_id?.sub_lead_source_type_id?.source_type}
        </div>
      ),
    },
    {
      field: "service",
      headerName: "Service",
      width: 150,
      headerClassName: "header-cell",
      headerAlign: "center",
      align: "center",
      valueGetter: (params) =>
        `${params.row?.enquiry_id?.service_id?.service_name || ""}`,
      renderCell: (params) => (
        <div>{params.row?.enquiry_id?.service_id?.service_name}</div>
      ),
    },
    {
      field: "sub_service",
      headerName: "Sub Service",
      width: 150,
      headerClassName: "header-cell",
      headerAlign: "center",
      align: "center",
      valueGetter: (params) =>
        `${params.row?.enquiry_id?.sub_service_id?.name || ""}`,
      renderCell: (params) => (
        <div>{params.row?.enquiry_id?.sub_service_id?.name}</div>
      ),
    },
    {
      field: "registrationStatus",
      headerName: "Registration Status",
      width: 250,
      headerClassName: "header-cell",
      valueGetter: (params) => `${params.row?.registration_status || ""}`,
      renderCell: (params) => <div>{params.row?.registration_status}</div>,
      headerAlign: "center",
      align: "center",
    },
    {
      field: "confirm_by_student",
      headerName: "Confirm By Student",
      width: 250,
      headerClassName: "header-cell",
      valueGetter: (params) => `${params.row?.confirm_by_student || ""}`,
      renderCell: (params) => <div>{params.row?.confirm_by_student}</div>,
      headerAlign: "center",
      align: "center",
    },

    {
      field: "visitStatus",
      headerName: "Visit Status",
      width: 100,
      headerClassName: "header-cell",
      valueGetter: (params) => `${params.row?.is_attended || ""}`,
      renderCell: (params) => (
        <div>{params.row?.is_attended ? "Yes" : "No"}</div>
      ),
      headerAlign: "center",
      align: "center",
    },
  ];

  const StyledGridOverlay = styled("div")(({ theme }) => ({
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    height: "100%",
    "& .ant-empty-img-1": {
      fill: theme.palette.mode === "light" ? "#aeb8c2" : "#262626",
    },
    "& .ant-empty-img-2": {
      fill: theme.palette.mode === "light" ? "#f5f5f7" : "#595959",
    },
    "& .ant-empty-img-3": {
      fill: theme.palette.mode === "light" ? "#dce0e6" : "#434343",
    },
    "& .ant-empty-img-4": {
      fill: theme.palette.mode === "light" ? "#fff" : "#1c1c1c",
    },
    "& .ant-empty-img-5": {
      fillOpacity: theme.palette.mode === "light" ? "0.8" : "0.08",
      fill: theme.palette.mode === "light" ? "#f5f5f5" : "#fff",
    },
  }));

  function CustomNoRowsOverlay() {
    return (
      <StyledGridOverlay>
        <Box sx={{ mt: 1 }}>No Data Available</Box>
      </StyledGridOverlay>
    );
  }

  const getRowClassName = (params) => {
    // Use the row index to alternate row colors (even rows white, odd rows gray)
    return params.index % 2 === 0 ? "row-odd" : "row-even";
  };

  const totalConnectedCalls = eventData.reduce((total, item) => {
    return item.enquiry_id?.connected_call !== 0 ? total + 1 : total;
  }, 0);

  const totalnonConnectedCalls = eventData.reduce((total, item) => {
    return item.enquiry_id?.not_connected_call !== 0 ? total + 1 : total;
  }, 0);

  const totalOpenTask = eventData.reduce((total, item) => {
    return item.enquiry_id?.total_open_task !== 0 ? total + 1 : total;
  }, 0);

  const totalRegisteredAndConfirmed = eventData.reduce((total, item) => {
    return item.registration_status === "Registered & Confirmed"
      ? total + 1
      : total;
  }, 0);

  const totalRegisteredAndNotConfirmed = eventData.reduce((total, item) => {
    return item.registration_status === "Registered & Not Confirmed"
      ? total + 1
      : total;
  }, 0);

  const totalNotRegisterd = eventData.reduce((total, item) => {
    return item.registration_status === "Not Registered" ? total + 1 : total;
  }, 0);

  const totalRecycle = eventData.reduce((total, item) => {
    return item.enquiry_id?.prospective_level_id?.prospective_level ===
      "Recycled"
      ? total + 1
      : total;
  }, 0);

  const totalWarm = eventData.reduce((total, item) => {
    return item.enquiry_id?.prospective_level_id?.prospective_level === "Warm"
      ? total + 1
      : total;
  }, 0);

  const totalNewLead = eventData.reduce((total, item) => {
    return item.enquiry_id?.prospective_level_id?.prospective_level ===
      "New lead"
      ? total + 1
      : total;
  }, 0);

  const totalActiveCounselling = eventData.reduce((total, item) => {
    return item.enquiry_id?.stage_id?.stage_name === "active counselling"
      ? total + 1
      : total;
  }, 0);

  const totalQualifyinf = eventData.reduce((total, item) => {
    return item.enquiry_id?.stage_id?.stage_name === "qualifying"
      ? total + 1
      : total;
  }, 0);

  const totalAssignment = eventData.reduce((total, item) => {
    return item.enquiry_id?.stage_id?.stage_name === "assignment"
      ? total + 1
      : total;
  }, 0);

  const totalBookDemo = eventData.reduce((total, item) => {
    return item.enquiry_id?.stage_id?.stage_name === "book demo"
      ? total + 1
      : total;
  }, 0);

  const totalDemoCompleted = eventData.reduce((total, item) => {
    return item.enquiry_id?.stage_id?.stage_name === "demo completed"
      ? total + 1
      : total;
  }, 0);

  const totalEnrolled = eventData.reduce((total, item) => {
    return item.enquiry_id?.stage_id?.stage_name === "enrolled"
      ? total + 1
      : total;
  }, 0);

  const totalTraining = eventData.reduce((total, item) => {
    return item.enquiry_id?.stage_id?.stage_name === "training"
      ? total + 1
      : total;
  }, 0);

  const totalTrainingCompleted = eventData.reduce((total, item) => {
    return item.enquiry_id?.stage_id?.stage_name === "training completed"
      ? total + 1
      : total;
  }, 0);

  useEffect(() => {
    const updatedList = [
      ...(eventList.length > 1
        ? [
            {
              campaign_name:
                eventname.length === eventList.length
                  ? "Deselect All"
                  : "Select All",
            },
          ]
        : []),
      ...eventList,
    ];
    setAllCampaignList(updatedList);
  }, [eventList, eventname]);

  const handelEventChange = (event, value) => {
    if (value.some((option) => option.campaign_name === "Select All")) {
      setEventName(eventList);
    } else if (
      value.some((option) => option.campaign_name === "Deselect All")
    ) {
      setEventName([]);
    } else {
      setEventName(value);
    }
  };

  const handleFromDateChange = (e) => {
    setFromDate(e.target.value);
  };

  const handleTodDateChange = (e) => {
    setEndDate(e.target.value);
  };

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await fetch(`${API_ENDPOINT}branch`);
        if (response.ok) {
          const data = await response.json();
          const sortedData = data.sort(
            (a, b) => new Date(b.createdAt) - new Date(a.createdAt),
          );
          setBranchlist(sortedData);
        } else {
          throw new Error(`Request failed with status: ${response.status}`);
        }
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };

    fetchData();
  }, []);

  const handelbranchchange = (e) => {
    const selectedValues = e.target.value;

    // If "Select All" is selected, toggle between selecting and deselecting all branches
    if (selectedValues.includes("all")) {
      const allIds = branchlist.map((branch) => branch.id);
      if (branch.length === allIds.length) {
        setBranch([]); // Deselect all branches
      } else {
        setBranch(allIds);
      }
    } else {
      setBranch(selectedValues);
      console.log(selectedValues);
    }
  };

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await fetch(`${API_ENDPOINT}eventregistrationstatus`);
        if (response.ok) {
          const data = await response.json();
          console.log("data", data);

          setRegistrationList(data);
        } else {
          throw new Error(`Request failed with status: ${response.status}`);
        }
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };

    fetchData();
  }, []);

  const allRegistrationList = [
    { registration_status: "Select All" },
    ...RegistrationList,
  ];

  const handleregStatusChange = (event, value) => {
    if (value.some((option) => option.registration_status === "Select All")) {
      setRegistrationstatus(RegistrationList);
    } else {
      setRegistrationstatus(value);
    }
  };

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await fetch(`${API_ENDPOINT}route/getalluser`);
        if (response.ok) {
          const data = await response.json();
          const sortedData = data.sort(
            (a, b) => new Date(b.createdAt) - new Date(a.createdAt),
          );
          setRegisteredByList(sortedData);
        } else {
          throw new Error(`Request failed with status: ${response.status}`);
        }
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };

    fetchData();
  }, []);

  const allRegisteredByList = [
    { first_name: "Select All" },
    ...registerdByList,
  ];

  const handleRegisterbychange = (event, value) => {
    if (value.some((option) => option?.first_name === "Select All")) {
      setRegisterdBy(registerdByList);
    } else {
      setRegisterdBy(value);
    }
  };

  const handlePermanentlyOwnerchange = (e) => {
    const selectedValues = e.target.value;

    // If "Select All" is selected, toggle between selecting and deselecting all branches
    if (selectedValues.includes("all")) {
      const allIds = registerdByList.map((item) => item.id);
      if (permanentlyOwner.length === allIds.length) {
        setPermentlyonner([]); // Deselect all branches
      } else {
        setPermentlyonner(allIds);
      }
    } else {
      setPermentlyonner(selectedValues);
      console.log(selectedValues);
    }
  };

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await fetch(`${API_ENDPOINT}service`);
        if (response.ok) {
          const data = await response.json();
          const sortedData = data.sort(
            (a, b) => new Date(b.createdAt) - new Date(a.createdAt),
          );
          setServiceList(sortedData);
        } else {
          throw new Error(`Request failed with status: ${response.status}`);
        }
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };

    fetchData();
  }, []);

  const handleServiceChange = (e) => {
    setService(e.target.value);
  };

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await fetch(`${API_ENDPOINT}prospectivelevel`);
        if (response.ok) {
          const data = await response.json();
          const sortedData = data.sort(
            (a, b) => new Date(b.createdAt) - new Date(a.createdAt),
          );
          setProspectiveLevelList(sortedData);
        } else {
          throw new Error(`Request failed with status: ${response.status}`);
        }
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };

    fetchData();
  }, []);

  const handleProspectivechange = (e) => {
    const selectedValues = e.target.value;

    // If "Select All" is selected, toggle between selecting and deselecting all branches
    if (selectedValues.includes("all")) {
      const allIds = prospectiveLevelList.map((item) => item.id);
      if (prosectiveLevel.length === allIds.length) {
        setProspectiveLevel([]); // Deselect all branches
      } else {
        setProspectiveLevel(allIds);
      }
    } else {
      setProspectiveLevel(selectedValues);
      console.log(selectedValues);
    }
  };

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await fetch(`${API_ENDPOINT}stage`);
        if (response.ok) {
          const data = await response.json();
          const sortedData = data.sort(
            (a, b) => new Date(b.createdAt) - new Date(a.createdAt),
          );
          setLeadstageList(sortedData);
        } else {
          throw new Error(`Request failed with status: ${response.status}`);
        }
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };

    fetchData();
  }, []);

  const handleLeadStagechange = (e) => {
    const selectedValues = e.target.value;

    // If "Select All" is selected, toggle between selecting and deselecting all branches
    if (selectedValues.includes("all")) {
      const allIds = leadStageList.map((item) => item.id);
      if (leadstage.length === allIds.length) {
        setLeadstage([]); // Deselect all branches
      } else {
        setLeadstage(allIds);
      }
    } else {
      setLeadstage(selectedValues);
      console.log(selectedValues);
    }
  };

  const handelNearbranchchange = (e) => {
    const selectedValues = e.target.value;

    // If "Select All" is selected, toggle between selecting and deselecting all branches
    if (selectedValues.includes("all")) {
      const allIds = branchlist.map((branch) => branch.id);
      if (nearestBranch.length === allIds.length) {
        setNearestBranch([]); // Deselect all branches
      } else {
        setNearestBranch(allIds);
      }
    } else {
      setNearestBranch(selectedValues);
      console.log(selectedValues);
    }
  };

  const handleFilterClick = (stageName) => {
    setSelectedFilters((prevSelectedFilters) => {
      if (prevSelectedFilters.includes(stageName)) {
        return prevSelectedFilters.filter((filter) => filter !== stageName);
      } else {
        return [...prevSelectedFilters, stageName];
      }
    });
  };

  console.log("filter", selectedFilters.length);

  useEffect(() => {
    const filteredData = eventData.filter((user) => {
      return selectedFilters.includes(user.enquiry_id?.stage_id?.stage_name);
    });
    if (selectedFilters.length > 0) {
      setEventOriginalData(filteredData);
    } else {
      setEventOriginalData(eventData);
    }
  }, [selectedFilters]);

  useEffect(() => {
    fetch(`${API_ENDPOINT}route/downloadaccess/${userId}`)
      .then((response) => {
        if (response.ok) {
          setIsDownloadAccess(true);
        } else {
          setIsDownloadAccess(false);
        }
      })
      .catch((err) => {
        setIsDownloadAccess(false);
      });
  }, [userId]);

  useEffect(() => {
    const exportData = eventOriginalData.map((row) => ({
      name: row.enquiry_id?.last_name
        ? `${row.enquiry_id?.first_name} ${row.enquiry_id.last_name}`
        : row.enquiry_id?.first_name,
      mobile: row.enquiry_id?.mobile || "",
      email: row.enquiry_id?.email || "",
      enquiry_date: row?.enquiry_id?.enquiry_date || "",
      contactable: row.enquiry_id?.connected_call || "",
      non_contactable: row.enquiry_id?.not_connected_call || "",
      open_tasks: row.enquiry_id?.total_open_task || "",
      last_followup_date: fDate(row.enquiry_id?.last_follow_up_date),
      next_followup_date: fDate(row.enquiry_id?.next_follow_up_date),

      nearest_branch: row.enquiry_id?.nearest_branch_id?.branch_name || "",
      enquiry_date: fDate(row.enquiry_id?.enquiry_date),
      service: row.enquiry_id?.service_id?.service_name || "",
      sub_service: row.enquiry_id?.sub_service_id?.name || "",

      event_name: row.event_id?.campaign_name,
      date_of_registration: fDate(row.registered_date),
      registered_by: row.registered_by?.first_name,
      assign: row.enquiry_id?.assign_to?.first_name || "",
      branch: row?.enquiry_id?.branch_id?.branch_name || "",

      prospective_level:
        row.enquiry_id?.prospective_level_id?.prospective_level || "",
      // sub_service: row.enquiry_id?.sub_service_id?.name || "",

      // lead_source_type: row.enquiry_id?.lead_source_type_id?.name || "",
      stage: row.enquiry_id?.stage_id?.stage_name || "",
      lead_source: row?.enquiry_id?.lead_source_type_id?.name || "",
      sub_lead_source_type:
        row?.enquiry_id?.sub_lead_source_type_id?.source_type || "",
      registration_status: row?.registration_status || "",
      reason_for_no_registration: row?.reason_for_no_registration || "",
      visit_status: row?.is_attended ? "Yes" : null,
    }));
    setExportData(exportData);
  }, [eventOriginalData]);

  // // Search By Name
  // const handleSearchByName = (e) => {
  //   const value = e.target.value;
  //   let filteredData1 = eventData.filter((data) =>
  //     `${data?.enquiry_id?.first_name} ${data?.enquiry_id?.last_name}`
  //       ?.toLowerCase()
  //       .replace(/\s+/g, "")
  //       .includes(value.toLowerCase().replace(/\s+/g, ""))
  //   );
  //   setEventOriginalData(filteredData1);
  // };

  const handleSearchByName = (e) => {
    const value = e.target.value.toLowerCase().replace(/\s+/g, ""); // Normalize search value (lowercase and remove spaces)

    let filteredData1 = eventData.filter((data) => {
      // Check each field for a match with the search value
      const fieldsToSearch = [
        `${data?.enquiry_id?.first_name || ""} ${
          data?.enquiry_id?.last_name || ""
        }`,
        `${data?.enquiry_id?.connected_call || ""}`,
        `${data?.enquiry_id?.not_connected_call || ""}`,
        `${data?.enquiry_id?.total_open_task || ""}`,
        `${data?.enquiry_id?.last_follow_up_date || ""}`,
        `${data?.enquiry_id?.next_follow_up_date || ""}`,
        `${data?.event_id?.campaign_name || ""}`,
        `${fDate(data?.registered_date || "")}`,
        `${data?.registered_by?.first_name || ""} ${
          data?.registered_by?.last_name || ""
        }`,
        `${data?.enquiry_id?.assign_to?.first_name || ""} ${
          data?.enquiry_id?.assign_to?.last_name || ""
        }`,
        `${data?.enquiry_id?.branch_id?.branch_name || ""}`,
        `${data?.enquiry_id?.nearest_branch_id?.branch_name || ""}`,
        `${data?.enquiry_id?.email || ""}`,
        `${data?.enquiry_id?.mobile || ""}`,
        `${data?.enquiry_id?.prospective_level_id?.prospective_level || ""}`,
        `${data?.enquiry_id?.stage_id?.stage_name || ""}`,
        `${data?.enquiry_id?.enquiry_date || ""}`,
        `${data?.enquiry_id?.lead_source_type_id?.name || ""}`,
        `${data?.enquiry_id?.sub_lead_source_type_id?.source_type || ""}`,
        `${data?.enquiry_id?.service_id?.service_name || ""}`,
        `${data?.enquiry_id?.sub_service_id?.name || ""}`,
        `${data?.registration_status || ""}`,
        `${data?.is_attended ? "Yes" : ""}`,
      ];

      // Check if any of the fields contain the search value
      return fieldsToSearch.some((field) =>
        field.toLowerCase().replace(/\s+/g, "").includes(value),
      );
    });

    setEventOriginalData(filteredData1); // Update the filtered data
  };

  // Removed Data from state after transfer
  const handleFilterdata = () => {
    const filteredData = eventOriginalData.filter(
      (i) => !selectedEnquiryId.includes(i.enquiry_id?.id),
    );
    setEventOriginalData(filteredData);
    setTimeout(() => {
      setSelectedid([]);
      setSelectedEnquiryids([]);
    }, 1500);
  };

  console.log("selectedEnquiryId", selectedEnquiryId);

  const handletoggleStatus = () => {
    setOpenStatus(!openstatus);
  };

  const handletoggleStages = () => {
    setOpenStages(!openstages);
  };

  const confirmationOptions = [
    { label: "Yes", value: 1 },
    { label: "No", value: 0 },
  ];

  const handleConfirmationStatusChange = (event, selectedOptions) => {
    const values = selectedOptions.map((item) => item.value);
    setConfirmationStatus(values);
  };

  return (
    <>
      <Backdrop open={loading} style={{ zIndex: 9999 }}>
        <Typography variant="h4" color="error" fontWeight={800} marginRight={2}>
          Fetching
        </Typography>
        <CircularProgress color="primary" />
      </Backdrop>

      <Grid item lg={12}>
        <Collapse in={open} fullWidth>
          <MainCard>
            <Grid container spacing={2}>
              <Grid item xs={12} lg={12} sm={12} md={12}>
                <Typography
                  variant="h4"
                  sx={{
                    color: "#2E4069",

                    marginTop: "20px",
                  }}
                >
                  Sub Service
                </Typography>

                {allSubservice.map((subservice) => (
                  <Chip
                    size="small"
                    key={subservice.id}
                    onClick={() => handleChangeSubservice(subservice.id)}
                    variant="outlined"
                    label={
                      subservice.id === 0
                        ? subServiceName.length === subServiceList.length
                          ? "Deselect All"
                          : "Select All"
                        : subservice.name
                    }
                    style={{
                      color: subServiceName.includes(subservice.id)
                        ? "green"
                        : "black",
                      fontWeight: 500,

                      margin: "5px",
                      border: subServiceName.includes(subservice.id)
                        ? "2px solid green"
                        : "",
                    }}
                  />
                ))}
              </Grid>

              <Grid item xs={12} lg={12} sm={12} md={12}>
                <Typography
                  variant="h4"
                  sx={{ color: "#2E4069", fontWeight: 600 }}
                >
                  Duration
                  <span
                    style={{
                      color: "red",
                      fontSize: "15px",
                      marginLeft: "3px",
                    }}
                  >
                    *
                  </span>
                </Typography>

                <Chip
                  size="small"
                  variant="outlined"
                  onClick={() => handleEventData({ eventType: "all" })}
                  label="All Event"
                  style={{
                    borderRadius: "25px",

                    margin: "5px",
                    border: eventType === "all" ? "2px solid green" : "",
                    fontWeight: 500,
                    color: eventType === "all" ? "green" : "black",
                  }}
                />

                <Chip
                  size="small"
                  variant="outlined"
                  onClick={() => handleEventData({ eventType: "past" })}
                  label="Past Event"
                  style={{
                    borderRadius: "25px",

                    margin: "5px",
                    border: eventType === "past" ? "2px solid green" : "",
                    fontWeight: 500,
                    color: eventType === "past" ? "green" : "black",
                  }}
                />

                <Chip
                  size="small"
                  variant="outlined"
                  onClick={() => handleEventData({ eventType: "running" })}
                  label="Running Event"
                  style={{
                    borderRadius: "25px",

                    margin: "5px",
                    border: eventType === "running" ? "2px solid green" : "",
                    fontWeight: 500,
                    color: eventType === "running" ? "green" : "black",
                  }}
                />

                <Chip
                  size="small"
                  variant="outlined"
                  onClick={() => handleEventData({ eventType: "upcoming" })}
                  label="Upcoming Event"
                  style={{
                    borderRadius: "25px",

                    margin: "5px",
                    border: eventType === "upcoming" ? "2px solid green" : "",
                    fontWeight: 500,
                    color: eventType === "upcoming" ? "green" : "black",
                  }}
                />

                <Chip
                  size="small"
                  variant="outlined"
                  onClick={() => handleEventData({ eventType: "custom" })}
                  label="Custom Event"
                  style={{
                    borderRadius: "25px",

                    margin: "5px",
                    border: eventType === "custom" ? "2px solid green" : "",
                    fontWeight: 500,
                    color: eventType === "custom" ? "green" : "black",
                  }}
                />

                {eventType === "custom" && (
                  <>
                    <CustomTextFieldComp
                      size="small"
                      InputProps={{ style: { borderRadius: "14px" } }}
                      InputLabelProps={{ shrink: true }}
                      type="date"
                      label="From Date"
                      variant="outlined"
                      sx={{ margin: "5px" }}
                      value={eventFromDate}
                      onChange={handleChangeEventFromdate}
                    />

                    <CustomTextFieldComp
                      size="small"
                      InputProps={{ style: { borderRadius: "14px" } }}
                      InputLabelProps={{ shrink: true }}
                      type="date"
                      label="To Date"
                      variant="outlined"
                      sx={{ margin: "5px" }}
                      value={eventToDate}
                      onChange={handleChangeEventTodate}
                    />

                    <Button
                      size="small"
                      variant="contained"
                      color="primary"
                      disabled={!eventFromDate || !eventToDate}
                      onClick={handleApplyFilter}
                    >
                      Apply{" "}
                    </Button>
                  </>
                )}
              </Grid>

              <Grid item xs={12} lg={2.8} md={6} sm={6}>
                <Typography variant="h6">Event</Typography>

                {/* <CustomAutocompleteComp
                  limitTags={1}
                  size="small"
                  noOptionsText={
                    eventloading && allcampaignList.length === 0
                      ? noOptionsText
                      : "Please Select Above Filter First"
                  }
                  multiple
                  value={eventname}
                  onChange={handelEventChange}
                  options={allcampaignList}
                  getOptionLabel={(option) => option.campaign_name}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      size="small"
                      InputProps={{
                        ...params.InputProps,
                        style: { borderRadius: "10px" }, // Add borderRadius here

                        endAdornment: (
                          <>
                            {eventloading ? (
                              <CircularProgress color="inherit" size={20} />
                            ) : null}
                            {params.InputProps.endAdornment}
                          </>
                        ),
                      }}
                    />
                  )}
                  renderTags={(value, getTagProps) =>
                    value.map((option, index) => (
                      <Tooltip
                        key={index}
                        title={option.campaign_name}
                      >
                        <span> 
                          <Chip
                          style={{cursor:'pointer'}}
                            label={option.campaign_name}
                            {...getTagProps({ index })}
                          />
                        </span>
                      </Tooltip>
                    ))
                  }
                /> */}
                <CustomAutocompleteComp
                  multiple
                  noOptionsText={
                    eventloading && allcampaignList.length === 0
                      ? noOptionsText
                      : "Please Select Above Filter First"
                  }
                  label="Event"
                  limitTags={1}
                  value={eventname}
                  onChange={handelEventChange}
                  options={allcampaignList}
                  getOptionLabel={(option) => option.campaign_name}
                  tooltipContent={(option) => option.campaign_name}
                  endAdornment={
                    eventloading ? (
                      <CircularProgress color="inherit" size={20} />
                    ) : null
                  }
                />
              </Grid>

              <Grid item xs={12} lg={1.8} sm={4} md={3}>
                <Typography variant="h6"> From Date</Typography>
                <CustomTextFieldComp
                  size="normal"
                  value={fromDate}
                  onChange={handleFromDateChange}
                  type="date"
                  fullWidth
                  InputProps={{
                    style: { borderRadius: "10px" },
                  }}
                />
              </Grid>

              <Grid item xs={12} lg={1.8} sm={4} md={3}>
                <Typography variant="h6"> To Date</Typography>
                <CustomTextFieldComp
                  size="normal"
                  value={endDate}
                  onChange={handleTodDateChange}
                  type="date"
                  fullWidth
                  InputProps={{
                    style: {
                      borderRadius: "10px",
                    },
                  }}
                />
              </Grid>

              {/* <Grid item xs={12} lg={3} md={6} sm={6}>
                <FormControl fullWidth>
                  <Typography sx={{ fontWeight: 600 }}>Branch</Typography>

                  <Select
                    sx={{ borderRadius: "14px" }}
                    value={branch}
                    onChange={handelbranchchange}
                    MenuProps={MenuProps}
                    multiple
                    renderValue={(selected) =>
                      selected
                        .map((value) => {
                          if (value === "all") return "Select All";
                          const branches = branchlist.find(
                            (status) => status.id === value
                          );
                          return branches ? branches.branch_name : "";
                        })
                        .join(", ")
                    }
                  >
                    <MenuItem key="select-all" value="all">
                      <Checkbox checked={branch.length === branchlist.length} />
                      <ListItemText primary="Select All" />
                    </MenuItem>
                    {branchlist.map((name) => (
                      <MenuItem key={name.id} value={name.id}>
                        <Checkbox checked={branch.indexOf(name.id) > -1} />
                        <ListItemText primary={name.branch_name} />
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
              </Grid> */}

              <Grid item xs={12} lg={2.7} md={4} sm={6}>
                <Typography variant="h6">Registered By</Typography>

                <CustomAutocompleteComp
                  multiple
                  limitTags={1}
                  value={registerBy}
                  options={allRegisteredByList}
                  onChange={handleRegisterbychange}
                  getOptionLabel={(option) =>
                    `${option.first_name ? option.first_name : ""} ${
                      option.last_name ? option.last_name : ""
                    }`
                  }
                  tooltipContent={(option) =>
                    `${option.first_name ? option.first_name : ""} ${
                      option.last_name ? option.last_name : ""
                    }`
                  }
                />
              </Grid>

              {/* <Grid item xs={12} lg={3} md={6} sm={6}>
                <FormControl fullWidth>
                  <Typography sx={{ fontWeight: 600 }}>
                    Permanently Owner
                  </Typography>

                  <Select
                    sx={{ borderRadius: "14px" }}
                    value={permanentlyOwner}
                    onChange={handlePermanentlyOwnerchange}
                    MenuProps={MenuProps}
                    multiple
                    renderValue={(selected) =>
                      selected
                        .map((value) => {
                          if (value === "all") return "Select All";
                          const data = registerdByList.find(
                            (status) => status.id === value
                          );
                          return data ? data.first_name : "";
                        })
                        .join(", ")
                    }
                  >
                    <MenuItem key="select-all" value="all">
                      <Checkbox
                        checked={
                          permanentlyOwner.length === registerdByList.length
                        }
                      />
                      <ListItemText primary="Select All" />
                    </MenuItem>
                    {registerdByList.map((name) => (
                      <MenuItem key={name.id} value={name.id}>
                        <Checkbox
                          checked={permanentlyOwner.indexOf(name.id) > -1}
                        />
                        <ListItemText
                          primary={`${
                            name.first_name !== null ? name.first_name : ""
                          } ${name.last_name !== null ? name.last_name : ""}`}
                        />
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
              </Grid> */}

              {/* <Grid item xs={12} lg={3} md={6} sm={6}>
                <FormControl fullWidth>
                  <Typography sx={{ fontWeight: 600 }}>Service</Typography>

                  <Select
                    multiple
                    MenuProps={MenuProps}
                    value={service}
                    onChange={handleServiceChange}
                    style={{ borderRadius: "15px" }}
                  >
                    {servicelist.map((item) => (
                      <MenuItem key={item.id} value={item.id}>
                        {item.service_name}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
              </Grid> */}

              {/* <Grid item xs={12} lg={3} md={6} sm={6}>
                <FormControl fullWidth>
                  <Typography sx={{ fontWeight: 600 }}>
                    Prospective Level
                  </Typography>

                  <Select
                    sx={{ borderRadius: "14px" }}
                    value={prosectiveLevel}
                    onChange={handleProspectivechange}
                    MenuProps={MenuProps}
                    multiple
                    renderValue={(selected) =>
                      selected
                        .map((value) => {
                          if (value === "all") return "Select All";
                          const data = prospectiveLevelList.find(
                            (status) => status.id === value
                          );
                          return data ? data.prospective_level : "";
                        })
                        .join(", ")
                    }
                  >
                    <MenuItem key="select-all" value="all">
                      <Checkbox
                        checked={
                          prosectiveLevel.length === prospectiveLevelList.length
                        }
                      />
                      <ListItemText primary="Select All" />
                    </MenuItem>
                    {prospectiveLevelList.map((name) => (
                      <MenuItem key={name.id} value={name.id}>
                        <Checkbox
                          checked={prosectiveLevel.indexOf(name.id) > -1}
                        />
                        <ListItemText primary={name.prospective_level} />
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
              </Grid> */}

              {/* <Grid item xs={12} lg={3} md={6} sm={6}>
                <FormControl fullWidth>
                  <Typography sx={{ fontWeight: 600 }}>Lead Stage</Typography>

                  <Select
                    sx={{ borderRadius: "14px" }}
                    value={leadstage}
                    onChange={handleLeadStagechange}
                    MenuProps={MenuProps}
                    multiple
                    renderValue={(selected) =>
                      selected
                        .map((value) => {
                          if (value === "all") return "Select All";
                          const data = leadStageList.find(
                            (status) => status.id === value
                          );
                          return data ? data.stage_name : "";
                        })
                        .join(", ")
                    }
                  >
                    <MenuItem key="select-all" value="all">
                      <Checkbox
                        checked={leadstage.length === leadStageList.length}
                      />
                      <ListItemText primary="Select All" />
                    </MenuItem>
                    {leadStageList.map((name) => (
                      <MenuItem key={name.id} value={name.id}>
                        <Checkbox checked={leadstage.indexOf(name.id) > -1} />
                        <ListItemText primary={name.stage_name} />
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
              </Grid> */}

              <Grid item xs={12} lg={2.7} md={4} sm={6}>
                <Typography variant="h6">Registration Status</Typography>

                {/* <CustomAutocompleteComp
                  limitTags={1}
                  size="small"
                  value={resterationstatus}
                  multiple
                  onChange={handleregStatusChange}
                  options={allRegistrationList}
                  getOptionLabel={(option) => option.registration_status}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      InputProps={{
                        ...params.InputProps,
                        style: { borderRadius: "10px" }, // Add borderRadius here
                      }}
                    />
                  )}
                /> */}

                <CustomAutocompleteComp
                  multiple
                  limitTags={1}
                  value={resterationstatus}
                  options={allRegistrationList}
                  onChange={handleregStatusChange}
                  getOptionLabel={(option) => option.registration_status}
                  tooltipContent={(option) => option.registration_status}
                />
              </Grid>

              <Grid item xs={12} lg={2.7} md={4} sm={6}>
                <Typography variant="h6">Confirm By Student</Typography>

                <CustomAutocompleteComp
                  multiple
                  limitTags={1}
                  value={confirmationStatus}
                  options={confirmationOptions}
                  onChange={(e, val) => {
                    // remove duplicates based on value
                    const unique = val.filter(
                      (item, index, self) =>
                        index === self.findIndex((t) => t.value === item.value),
                    );

                    setConfirmationStatus(unique);
                  }}
                  getOptionLabel={(option) => option.label}
                  tooltipContent={(option) => option.label}
                  filterSelectedOptions
                />
              </Grid>

              {/* <Grid item xs={12} lg={3} md={6} sm={6}>
                <FormControl fullWidth>
                  <Typography sx={{ fontWeight: 600 }}>
                    Nearest Branch
                  </Typography>

                  <Select
                    sx={{ borderRadius: "14px" }}
                    value={nearestBranch}
                    onChange={handelNearbranchchange}
                    MenuProps={MenuProps}
                    multiple
                    renderValue={(selected) =>
                      selected
                        .map((value) => {
                          if (value === "all") return "Select All";
                          const branches = branchlist.find(
                            (status) => status.id === value
                          );
                          return branches ? branches.branch_name : "";
                        })
                        .join(", ")
                    }
                  >
                    <MenuItem key="select-all" value="all">
                      <Checkbox
                        checked={nearestBranch.length === branchlist.length}
                      />
                      <ListItemText primary="Select All" />
                    </MenuItem>
                    {branchlist.map((name) => (
                      <MenuItem key={name.id} value={name.id}>
                        <Checkbox
                          checked={nearestBranch.indexOf(name.id) > -1}
                        />
                        <ListItemText primary={name.branch_name} />
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
              </Grid> */}

              <Grid item xs={12} md={12} lg={12} sm={12}>
                <Grid container gap={2} justifyContent="end">
                  <SearchButton
                    onClick={handleSubmit}
                    label="Search"
                    showIcon={true}
                  />

                  <ResetButtonComp
                    label="Clear"
                    onClick={handleresetFilterData}
                  />
                </Grid>
              </Grid>
            </Grid>
          </MainCard>
        </Collapse>
      </Grid>

      <Grid item xs={12} md={12} sm={12} lg={12}>
        <MainCard>
          <Grid container spacing={2}>
            <Grid item xs={12}>
              <Grid container justifyContent="flex-end" gap={2}>
                <MassTaskAssignButton onClick={handleOpenmask} />

                <SendEmailButton onClick={handleOpenEmail} />

                {isDownloadAccess && (
                  <CSVExport data={exportData} filename="event-report.csv" />
                )}
              </Grid>
            </Grid>
            {/* <Grid
            item
            xs={12}
            sx={{
              display: "flex",
              flexDirection: "row",
              alignItems: "center",
              marginBottom: "14px",
            }}
          >
            <InfoCard label="Total:" value={eventData.length} color="#46BB4A" />
            <InfoCard
              label="Contactable:"
              value={totalConnectedCalls}
              color="#46BB4A"
            />
            <InfoCard
              label="Not Contactable:"
              value={totalnonConnectedCalls}
              color="#46BB4A"
            />
            <InfoCard
              label="Open Task:"
              value={totalOpenTask}
              color="#46BB4A"
            />
          </Grid>
          <Grid
            item
            xs={12}
            sx={{
              display: "flex",
              flexDirection: "row",
              alignItems: "center",
              marginBottom: "14px",
            }}
          >
            <InfoCard
              label="Registered & Confirmed:"
              value={totalRegisteredAndConfirmed}
              color="#F44336"
            />
            <InfoCard
              label="Registered & Not Confirmed:"
              value={totalRegisteredAndNotConfirmed}
              color="#F44336"
            />
            <InfoCard
              label="Not Registered:"
              value={totalNotRegisterd}
              color="#F44336"
            />
           
          </Grid>

          <Grid
            item
            xs={12}
            sx={{
              display: "flex",
              flexDirection: "row",
              alignItems: "center",
              marginBottom: "14px",
            }}
          >
            <InfoCard label="Recycle:" value={totalRecycle} color="#46BB4A" />
            <InfoCard label="Warm:" value={totalWarm} color="#46BB4A" />
            <InfoCard label="New Lead:" value={totalNewLead} color="#46BB4A" />
          </Grid> */}
            <Grid item xs={12}>
              <Box
                display="flex"
                flexDirection="row"
                alignItems="center"
                style={{ cursor: "pointer" }}
                onClick={handletoggleStatus}
              >
                <Typography variant="h4">Registration Status </Typography>
                {!openstatus ? (
                  <KeyboardArrowDownIcon fontSize="small" />
                ) : (
                  <KeyboardArrowUpIcon fontSize="small" />
                )}
              </Box>{" "}
            </Grid>
            {openstatus && (
              <Grid item xs={12}>
                <Box
                  sx={{
                    border: "1px solid #888888",
                    padding: "10px",
                    borderRadius: "10px",
                    display: "flex",
                    gap: 1,
                    flexWrap: "wrap",
                    alignItems: "center",
                    justifyContent: "space-evenly",
                  }}
                >
                  <Typography variant="h6">
                    Total: {eventData.length}
                  </Typography>
                  <Box
                    sx={{ borderLeft: "1px solid #888888", height: "20px" }}
                  />

                  <Typography variant="h6">
                    Contactable: {totalConnectedCalls}
                  </Typography>
                  <Box
                    sx={{ borderLeft: "1px solid #888888", height: "20px" }}
                  />

                  <Typography variant="h6">
                    Not Contactable: {totalnonConnectedCalls}
                  </Typography>
                  <Box
                    sx={{ borderLeft: "1px solid #888888", height: "20px" }}
                  />

                  <Typography variant="h6">
                    Open Task: {totalOpenTask}
                  </Typography>
                  <Box
                    sx={{ borderLeft: "1px solid #888888", height: "20px" }}
                  />

                  <Typography variant="h6">
                    Registered & Confirmed: {totalRegisteredAndConfirmed}
                  </Typography>
                  <Box
                    sx={{ borderLeft: "1px solid #888888", height: "20px" }}
                  />

                  <Typography variant="h6">
                    Registered & Not Confirmed: {totalRegisteredAndNotConfirmed}
                  </Typography>
                  <Box
                    sx={{ borderLeft: "1px solid #888888", height: "20px" }}
                  />

                  <Typography variant="h6">
                    Not Registered: {totalNotRegisterd}
                  </Typography>
                  <Box
                    sx={{ borderLeft: "1px solid #888888", height: "20px" }}
                  />

                  <Typography variant="h6">Recycle: {totalRecycle}</Typography>
                  <Box
                    sx={{ borderLeft: "1px solid #888888", height: "20px" }}
                  />

                  <Typography variant="h6">Warm: {totalWarm}</Typography>
                  <Box
                    sx={{ borderLeft: "1px solid #888888", height: "20px" }}
                  />

                  <Typography variant="h6">New Lead: {totalNewLead}</Typography>
                </Box>
              </Grid>
            )}
            <Grid item xs={12}>
              <Box
                display="fles"
                alignItems="center"
                cursor="pointer"
                style={{ cursor: "pointer" }}
                onClick={handletoggleStages}
              >
                <Typography variant="h4">Stages</Typography>
                {!openstages ? (
                  <KeyboardArrowDownIcon fontSize="small" />
                ) : (
                  <KeyboardArrowUpIcon fontSize="small" />
                )}
              </Box>
              {openstages && (
                <Grid container gap={1} mt={1}>
                  <OutlinedButtonComp
                    value={totalActiveCounselling}
                    borderRadius="25px"
                    borderColor={
                      selectedFilters.includes("active counselling")
                        ? "green"
                        : "#b2b2b4"
                    }
                    color={
                      selectedFilters.includes("active counselling")
                        ? "green"
                        : "black"
                    }
                    label="Active Counselling :"
                    margin="6px"
                    fontWeight="500"
                    onClick={() => handleFilterClick("active counselling")}
                  />

                  <OutlinedButtonComp
                    value={totalQualifyinf}
                    borderRadius="25px"
                    borderColor={
                      selectedFilters.includes("qualifying")
                        ? "green"
                        : "#b2b2b4"
                    }
                    color={
                      selectedFilters.includes("qualifying") ? "green" : "black"
                    }
                    label="Qualifying :"
                    margin="6px"
                    onClick={() => handleFilterClick("qualifying")}
                  />

                  <OutlinedButtonComp
                    value={totalAssignment}
                    borderRadius="25px"
                    borderColor={
                      selectedFilters.includes("assignment")
                        ? "green"
                        : "#b2b2b4"
                    }
                    color={
                      selectedFilters.includes("assignment") ? "green" : "black"
                    }
                    label="Assignment :"
                    margin="6px"
                    onClick={() => handleFilterClick("assignment")}
                  />

                  <OutlinedButtonComp
                    value={totalBookDemo}
                    borderRadius="25px"
                    borderColor={
                      selectedFilters.includes("book demo")
                        ? "green"
                        : "#b2b2b4"
                    }
                    color={
                      selectedFilters.includes("book demo") ? "green" : "black"
                    }
                    label=" Book demo :"
                    margin="6px"
                    onClick={() => handleFilterClick("book demo")}
                  />

                  <OutlinedButtonComp
                    value={totalDemoCompleted}
                    borderRadius="25px"
                    borderColor={
                      selectedFilters.includes("demo completed")
                        ? "green"
                        : "#b2b2b4"
                    }
                    color={
                      selectedFilters.includes("demo completed")
                        ? "green"
                        : "black"
                    }
                    label="Demo completed :"
                    margin="6px"
                    onClick={() => handleFilterClick("demo completed")}
                  />

                  <OutlinedButtonComp
                    value={totalEnrolled}
                    borderRadius="25px"
                    borderColor={
                      selectedFilters.includes("enrolled") ? "green" : "#b2b2b4"
                    }
                    color={
                      selectedFilters.includes("enrolled") ? "green" : "black"
                    }
                    label="Enrolled :"
                    margin="6px"
                    onClick={() => handleFilterClick("enrolled")}
                  />

                  <OutlinedButtonComp
                    value={totalTraining}
                    borderRadius="25px"
                    borderColor={
                      selectedFilters.includes("training") ? "green" : "#b2b2b4"
                    }
                    color={
                      selectedFilters.includes("training") ? "green" : "black"
                    }
                    label=" Training :"
                    margin="6px"
                    onClick={() => handleFilterClick("training")}
                  />

                  <OutlinedButtonComp
                    value={totalTrainingCompleted}
                    borderRadius="25px"
                    borderColor={
                      selectedFilters.includes("training completed")
                        ? "green"
                        : "#b2b2b4"
                    }
                    color={
                      selectedFilters.includes("training completed")
                        ? "green"
                        : "black"
                    }
                    label="  Training Completed : "
                    margin="6px"
                    onClick={() => handleFilterClick("training completed")}
                  />
                </Grid>
              )}
            </Grid>

            {/* <Grid item xs={12} lg={6} sm={6} md={6}>
              <SelectedItemButton
                variant="contained"
                size="small"
                value={selectedid.length}
              />
            </Grid> */}

            <Grid
              item
              xs={12}
              sm={12}
              md={6}
              container
              gap={1}
              alignItems="center"
            >
              <Chip
                label={
                  eventOriginalData.length !== selectedid.length ||
                  eventOriginalData.length === 0
                    ? "Select All"
                    : "Deselect All"
                }
                variant="outlined"
                size="small"
                onClick={() => handleSelectAllData()}
              />
              <SelectedItemButton value={selectedid.length} />
            </Grid>

            <Grid
              item
              xs={12}
              sm={6}
              sx={{
                display: "flex",
                alignItems: "center",
                flexDirection: "row",
                justifyContent: "end",
              }}
            >
              {/* <CustomTextFieldComp
                size="normal" // You can customize size
                onchange={handleSearchByName}
                style={{ width: "200px" }} // Additional props can be added like fullWidth, helperText, etc.
              /> */}
              <SearchTextFieldComp
                width="200px"
                onChange={handleSearchByName}
              />
            </Grid>

            <DataGrid
              key={gridKey}
              disableColumnSorting={true}
              disableColumnFilter // Disables the filter functionality globally
              disableColumnSelector // Disables the column selector
              rows={eventOriginalData}
              columns={columns}
              autoHeight
              slots={{
                noRowsOverlay: CustomNoRowsOverlay,
              }}
              pageSize={pagination.pageSize}
              onPaginationModelChange={(model) => setPagination(model)}
              sx={{ marginTop: "20px" }}
              pageSizeOptions={[10, 25, 50, 100]}
              getRowClassName={getRowClassName}
            />
          </Grid>
        </MainCard>
      </Grid>

      {selectedid.length === 0 ? (
        <CustomPopup
          open={openMask}
          onClose={handleClosemask}
          component={<NoenquiryForm onClose={handleClosemask} />}
          maxWidth="xs"
        />
      ) : (
        <CustomPopup
          open={openMask}
          onClose={handleClosemask}
          component={
            <MassTaskAssign
              onClose={handleClosemask}
              selectedEnquiryIds={selectedEnquiryId}
              setSelectedEnquiryIds={setSelectedEnquiryids}
              handleFilterdata={handleFilterdata}
            />
          }
          title="Mass Task Assign"
          maxWidth="md"
          showDivider={true}
        />
      )}

      {selectedid.length === 0 ? (
        <CustomPopup
          open={OpenEmailPopup}
          onClose={handleCloseEmail}
          component={<NoeMailForm onClose={handleCloseEmail} />}
          maxWidth="xs"
        />
      ) : (
        <BulkEmailPopup
          open={OpenEmailPopup}
          handelclose={handleCloseEmail}
          component={
            <BulkMailform
              handelclose={handleCloseEmail}
              selectedId={selectedEnquiryId}
            />
          }
          title="Send Bulk Emails"
          maxWidth="md"
          showDivider={true}
        />
      )}

      <CustomSnackbar
        open={snackbarOpen}
        onClose={() => setSnackbarOpen(false)}
        message={snackbarMessage}
        severity={snackbarSeverity}
      />
    </>
  );
}
